module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_4-9ce48d8725d965956b8ca40b47d07b3a.png";